<template>
  <naj-box title="بيانات الخطاب">
    <v-row>
      <v-col
        cols="12"
        lg="6"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.representative.letterDate"
          :value.sync="formModel.letterDate"
          :disabled="viewMode"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          v-if="isType(formModel.relatedPartyType,'government')"
          :type-id="formFieldType.selectbox"
          :label="local.representative.letterSourceId"
          :value.sync="formModel.letterSourceId"
          :value-name.sync="formModel.letterSourceName"
          :disabled="viewMode"
          :items="governmentAgencies"
          item-text="organizationName"
          item-value="id"
          validates="required"
        ></naj-input>
        <naj-input
          v-else
          :type-id="formFieldType.text"
          :label="local.representative.letterSourceId"
          :disabled="viewMode"
          :value.sync="formModel.letterSourceName"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.representative.letterNumber"
          :value.sync="formModel.letterNumber"
          :disabled="viewMode"
          validates="required"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { isType } from '../../../../helpers/utils';

const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  props: ['formModel', 'viewMode'],
  data() {
    return { isType };
  },
  computed: { ...mapLUTState(['governmentAgencies']) },
  created() {
    this.getGovernmentAgencies();
  },
  methods: { ...mapLUTActions(['getGovernmentAgencies']) },
};
</script>
